import { faExternalLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetOrganizationAccountLinkLazyQuery } from 'lib/graphql/graphql';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ContainedLoadingButton } from 'styles/styles';

interface AccountLinkButtonProps {
  canReceivePayments: boolean;
  stripeAccountId: string
  stripeAccountLinked: boolean
}

function AccountLinkButton(props: AccountLinkButtonProps) {
  const { canReceivePayments, stripeAccountId, stripeAccountLinked } = props;

  const [createAccountLink] = useGetOrganizationAccountLinkLazyQuery();

  const [loading, setLoading] = useState<boolean>(false);

  const handleClick = useCallback(async () => {
    if (!canReceivePayments) {
      setLoading(true);
      const { data } = await createAccountLink({
        variables: {
          stripeAccountId,
        },
        fetchPolicy: 'network-only',
      });
      if (data && data.getOrganizationAccountLink) {
        window.open(data.getOrganizationAccountLink, '_blank');
      }
      setLoading(false);
    }
  }, [canReceivePayments, createAccountLink, stripeAccountId]);

  let label;
  switch (true) {
    case stripeAccountLinked && !canReceivePayments:
      label = 'stripe_need_info';
      break;
    case stripeAccountLinked:
      label = 'stripe_already_linked';
      break;
    default:
      label = 'stripe_link_account';
  }

  return (
    <ContainedLoadingButton
      loading={loading}
      onClick={handleClick}
      disabled={loading || canReceivePayments}
      color="secondary"
      endIcon={<FontAwesomeIcon icon={faExternalLink} />}
    >
      <FormattedMessage id={label} />
    </ContainedLoadingButton>
  );
}

export default AccountLinkButton;
